module.exports = __webpack_public_path__ + "img/auto-compras.b13bd671.webp";